<template>
  <div class="member-management-page">
    <!-- 標題區 -->
    <h2>訂單管理</h2>
    
    <!-- 搜尋區 -->
    <div class="search-bar-top">
      <div class="search-input-container">
        <i class="search-icon fas fa-search"></i>
        <input type="text" placeholder="搜尋用戶名稱" v-model="searchQuery" />
      </div>
      <button class="action-button" @click="fetchOrders">查詢訂單</button>
    </div>

    <!-- 訂單表格 -->
    <table class="member-table">
      <thead>
        <tr>
          <th>用戶名稱</th>
          <th>訂單編號</th>
          <th>總金額</th>
          <th>訂單日期</th>
          <th>付款狀態</th>
          <th>訂單狀態</th>
          <th>訂單詳情</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in filteredOrders" :key="order.orderId">
          <td>{{ order.userName }}</td>
          <td>{{ order.orderId }}</td>
          <td>{{ order.totalAmount }}</td>
          <td>{{ formatDate(order.orderDate) }}</td>
          <td>
            <span
              :class="order.paymentStatus === '已付款' ? 'status-confirmed' : 'status-pending'"
            >
              {{ order.paymentStatus }}
            </span>
          </td>
          <td>{{ order.orderStatus }}</td>
          <td>
            <button class="btn btn-edit" @click="openModal(order)">查看</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 模態窗 -->
    <div v-if="showModal" class="edit-modal">
      <div class="modal">
        <div class="modal-header">
          <h2>訂單詳情</h2>
          <button class="close-button" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <p><strong>用戶名稱：</strong>{{ currentOrder.userName }}</p>
          <p><strong>訂單編號：</strong>{{ currentOrder.orderId }}</p>
          <p><strong>總金額：</strong>{{ currentOrder.totalAmount }}</p>
          <p><strong>訂單日期：</strong>{{ formatDate(currentOrder.orderDate) }}</p>
          <p>
            <strong>付款狀態：</strong>
            <select v-model="currentOrder.paymentStatus">
              <option value="未付款">未付款</option>
              <option value="已付款">已付款</option>
            </select>
          </p>
          <p>
            <strong>訂單狀態：</strong>
            <select v-model="currentOrder.orderStatus">
              <option value="訂單成立">訂單成立</option>
              <option value="已完成">已完成</option>
              <option value="已取消">已取消</option>
            </select>
          </p>
          <h3>訂單明細：</h3>
          <ul>
            <li v-for="detail in currentOrder.orderDetails" :key="detail.roomTypeId">
              房型名稱：{{ detail.roomTypeName }}，
              入住日期：{{ formatDate(detail.checkInDate) }}，
              退房日期：{{ formatDate(detail.checkOutDate) }}，
              數量：{{ detail.quantity }}，
              單價：{{ detail.unitPrice }}，
              小計：{{ detail.subtotal }}
            </li>
          </ul>
        </div>
        <div class="modal-actions">
          <button class="update-button" @click="updateOrder">更新</button>
          <button class="cancel-button" @click="closeModal">關閉</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderManagementScript from '@/assets/js/background/OrderManagement.js';

export default OrderManagementScript;
</script>

<style src="@/assets/css/background/order.css" scoped></style>
